export enum LinkType {
  SMART = 'smart',
  SHORT = 'short',
}
